import { Component } from '@angular/core';
import { ContainerComponent } from '../layout/container/container.component';

@Component({
  selector: 'app-info-adicional',
  standalone: true,
  imports: [ContainerComponent],
  templateUrl: './info-adicional.component.html',
  styleUrl: './info-adicional.component.scss'
})
export class InfoAdicionalComponent {

}
